import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { JobsService } from './jobs-service';

@Injectable({
  providedIn: 'root',
})
export class LicenseTypesResolver {
  constructor(
    private jobsService: JobsService,
    private applicationModel: ApplicationModel
  ) {}

  public load(): Observable<never> {
    if (this.applicationModel.licenseTypes.length === 0) {
      this.jobsService.fetchLicenseTypes().subscribe((data) => {
        this.applicationModel.licenseTypes = data;
      });
      return EMPTY;
    }

    return EMPTY;
  }
}
